const STORE_V1 = '/api/store/v1';

export const ENDPOINTS = {
  TENANT_RESOLVE: `${STORE_V1}/tenant/resolve`,
  STOREFRONT_THEME: `${STORE_V1}/storefront/theme`,
  STOREFRONT_LAYOUT: `${STORE_V1}/storefront/layout`,
  STOREFRONT_NAVIGATION: `${STORE_V1}/storefront/navigation`,
  STOREFRONT_FEATURES: `${STORE_V1}/storefront/features`,
  CATEGORIES: `${STORE_V1}/catalog/categories`,
  CATEGORY_BY_SLUG: (slug: string) => `${STORE_V1}/catalog/categories/${encodeURIComponent(slug)}`,
  PRODUCTS: `${STORE_V1}/products`,
  PRODUCT_BY_SLUG: (slug: string) => `${STORE_V1}/products/${encodeURIComponent(slug)}`,
  PRODUCT_RELATED: (id: string) => `${STORE_V1}/products/${encodeURIComponent(id)}/related`,
  BRANDS: `${STORE_V1}/brands`,
  BRAND_BY_SLUG: (slug: string) => `${STORE_V1}/brands/${encodeURIComponent(slug)}`,
  PROMOTIONS: `${STORE_V1}/promotions`,
  NEWS: `${STORE_V1}/news`,
  SEARCH: `${STORE_V1}/search`,
  AUTH_REGISTER: `${STORE_V1}/auth/register`,
  AUTH_LOGIN: `${STORE_V1}/auth/login`,
  AUTH_REFRESH: `${STORE_V1}/auth/refresh`,
  AUTH_FORGOT: `${STORE_V1}/auth/forgot-password`,
  AUTH_RESET: `${STORE_V1}/auth/reset-password`,
  AUTH_ACTIVATE: `${STORE_V1}/auth/activate`,
  AUTH_B2B_REQUEST: `${STORE_V1}/auth/b2b-access-request`,
  AUTH_LOGOUT: `${STORE_V1}/auth/logout`,
  ACCOUNT_PROFILE: `${STORE_V1}/account/profile`,
  ACCOUNT_ADDRESSES: `${STORE_V1}/account/addresses`,
  ACCOUNT_ADDRESS: (id: string) => `${STORE_V1}/account/addresses/${encodeURIComponent(id)}`,
  ACCOUNT_LOCALITIES: `${STORE_V1}/account/localities`,
  ACCOUNT_ORDERS: `${STORE_V1}/account/orders`,
  ACCOUNT_ORDER_TRACKING: (id: string) => `${STORE_V1}/account/orders/${encodeURIComponent(id)}/tracking`,
  ACCOUNT_FAVORITES: `${STORE_V1}/account/favorites`,
  ACCOUNT_FAVORITE: (productId: string) => `${STORE_V1}/account/favorites/${encodeURIComponent(productId)}`,
  ACCOUNT_HISTORY: `${STORE_V1}/account/history`,
  CART: `${STORE_V1}/cart`,
  CART_ITEMS: `${STORE_V1}/cart/items`,
  CART_ITEM: (id: string | number) => `${STORE_V1}/cart/items/${encodeURIComponent(String(id))}`,
  CHECKOUT: `${STORE_V1}/checkout`,
  CHECKOUT_SHIPPING: `${STORE_V1}/checkout/shipping-options`,
  CATALOG_CONFIG: `${STORE_V1}/catalog/config`,
  BRANCHES: `${STORE_V1}/branches`,
  PRICE_LISTS: `${STORE_V1}/price-lists`,
  ADMIN_AUTH_LOGIN: `${STORE_V1}/admin/auth/login`,
  ADMIN_AUTH_EXCHANGE: `${STORE_V1}/admin/auth/exchange`,
  ADMIN_STOREFRONT_THEME: `${STORE_V1}/admin/storefront/theme`,
  ADMIN_STOREFRONT_LAYOUT: `${STORE_V1}/admin/storefront/layout`,
  ADMIN_STOREFRONT_NAVIGATION: `${STORE_V1}/admin/storefront/navigation`,
  ADMIN_STOREFRONT_FEATURES: `${STORE_V1}/admin/storefront/features`,
  ADMIN_STOREFRONT_ASSETS: `${STORE_V1}/admin/storefront/assets`,
  ADMIN_CATALOG_SETTINGS: `${STORE_V1}/admin/catalog/settings`,
} as const;
